<!--
* @Description: 字符串超长截取省略号显示组件
-->

<template>
    <div >
        <template v-if="value.length > length">
            <a-tooltip placement="topLeft" :overlayStyle="{maxWidth: maxWidth}">
                <template slot="title">
                    <span>{{ value }}</span>
                </template>
                {{ value | ellipsis(length) }}
            </a-tooltip>
        </template>
        <template v-else>
            <span>{{ value }}</span>
        </template>
    </div>
</template>

<script>
export default {
    name: 'Ellipsis',
    props: {
        value: {
            type: String,
            required: false,
        },
        length: {
            type: Number,
            required: false,
            default: 25,
        },
        maxWidth: {
            type: String,
            required: false,
            default: 'auto',
        }
    },
}
</script>

<style scoped></style>
